var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "coupon-filters"
  }, _vm._l(_vm.options, function (option) {
    return _c('div', {
      key: option.key,
      staticClass: "coupon-filters--option",
      class: {
        isActive: option.key === _vm.activeFilter
      },
      on: {
        "click": function click($event) {
          return _vm.handleClick(option.key);
        }
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }